// Disclaimer about this file.
// otan ksekinisame na ftiaxnoume to error component thelame otan skaei error

// na min sunexizoun na trexoun apo pisw ta requests
// opt auto pou eprepe na kanoume itan :
// - na kanoume form to action
// - na kanoume delete to action gia na min trexei
// opt gia na min to kanoume kathe fora to kaname wrap sti sagalisten
// k leme oti tha ginetai unblock
// me to finally action i me error action
import { buffers } from 'redux-saga';
import { flush, fork, take, cancel, actionChannel } from 'redux-saga/effects';
import { GENERIC_ERROR, LOG_OUT } from 'containers/App/constants';

/**
 *
 * @param onAction wait the onAction to be called in order to start the execution,
 * <strong>ALWAYS</strong> on the <strong>actionToFork</strong>
 * we should call(put) on a finally block the <strong>`${onAction}_FINISHED`</strong>
 * @param actionToFork the saga generator function that will handle the execution
 */
export default function* sagaListen(onAction, actionToFork) {
  while (true) {
    // eslint-disable-line no-constant-condition
    // starts the task in the background
    const action = yield take(onAction);
    const sagaTask = yield fork(actionToFork, action);
    // wait for the generic error or log out action or the error thrown above
    yield take([GENERIC_ERROR, LOG_OUT, `${onAction}_FINISHED`]);
    yield cancel(sagaTask);
  }
}

/**
 *
 * @param onAction wait the onAction to be called in order to start the execution,
 * @param actionToFork the saga generator function that will handle the execution
 */
export function* sagaListenLatest(onAction, actionToFork) {
  let lastSagaTask;
  while (true) {
    // wait for a repeat action or the generic error or log out action or the error thrown above
    const action = yield take([onAction, GENERIC_ERROR, LOG_OUT]);
    if (lastSagaTask) {
      yield cancel(lastSagaTask);
    }

    if (action.type === onAction) {
      lastSagaTask = yield fork(actionToFork, action);
    }
  }
}

export function* sagaQueueLatest(
  onAction,
  actionToFork,
  buffer = buffers.sliding(1),
) {
  const requestChannel = yield actionChannel(onAction, buffer);
  while (true) {
    const action = yield take(requestChannel);
    const sagaTask = yield fork(actionToFork, action);
    const resultingAction = yield take([
      GENERIC_ERROR,
      LOG_OUT,
      `${onAction}_FINISHED`,
    ]);
    if (resultingAction.type !== `${onAction}_FINISHED`) {
      yield flush(requestChannel);
    }
    yield cancel(sagaTask);
  }
}
